import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { Page as HomePage } from './pages/home'
import { Page as NotFoundPage } from './pages/home/not-found-error'
import { Page as LabPage } from './pages/lab'
import { Page as ShortAnswerPage } from './pages/lab/quiz/short-answer'
import { Page as SelfAffirmationContentPage } from './pages/epub/self-affirmation/content'
import { Page as PlayBookOpenPage} from './pages/epub/self-affirmation/content-temp/play-book-open'
import { Page as SelfAffirmationPage } from './pages/epub/self-affirmation'

const Router = () => {
    return (
      <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />

            <Route path="/epub/self-affirmation" element={<SelfAffirmationPage />} />
            <Route path="/epub/self-affirmation/content/:id" element={<SelfAffirmationContentPage />} />
            <Route path="/epub/self-affirmation/content-temp/play-book-open" element={<PlayBookOpenPage />} />

            <Route path="/lab" element={<LabPage />} />
            <Route path="/lab/quiz/short-answer" element={<ShortAnswerPage />} />

            <Route path='*' element={<NotFoundPage />} />
          </Routes>
      </BrowserRouter>
    );
  };

export default Router;
